export default __webpack_public_path__ + "static/media/ser10.a77376cd.svg";